import React from 'react'
import Button from "../../component/Button/Button";
import Modal from "react-bootstrap/Modal";
import {Form} from "react-bootstrap";
import {faTrash, faXmarkCircle} from "@fortawesome/free-solid-svg-icons";

class DeleteRole extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            confirmName: '',
            errorMessage: '',
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleConfirmNameChange = this.handleConfirmNameChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    handleShow() {
        this.setState({show: true, confirmName: '', errorMessage: ''});
    }

    handleClose() {
        this.setState({show: false, confirmName: '', errorMessage: ''});
    }

    handleConfirmNameChange(event) {
        this.setState({confirmName: event.target.value});
    }

    handleDelete() {
        if (this.state.confirmName === this.props.roleName) {
            this.props.delete(this.props.roleId);
            // Don't close modal - parent will redirect away from page
        } else {
            this.setState({errorMessage: `"${this.state.confirmName}" does not match the role name "${this.props.roleName}"`});
        }
    }

    render() {
        const { roleName } = this.props;
        const { show, confirmName, errorMessage } = this.state;
        const isConfirmValid = confirmName === roleName;

        return <>
            <Button className="secondary-outline btn btn-md" faIcon={faTrash} label="Delete" onClick={this.handleShow}/>

            <Modal show={show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Permanently delete role</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete role: <strong>{roleName}</strong>?</p>
                    <p>This will also delete all S3 keys associated with this role.</p>
                    <p>To confirm, type the role name below:</p>
                    <Form.Control
                        type="text"
                        placeholder={roleName}
                        value={confirmName}
                        onChange={this.handleConfirmNameChange}
                    />
                    {errorMessage && <p className="text-danger mt-2">{errorMessage}</p>}
                </Modal.Body>
                <Modal.Footer>
                    <Button className="cancel-outline btn" faIcon={faXmarkCircle} label="Cancel" onClick={this.handleClose}/>
                    <Button
                        className="secondary btn"
                        faIcon={faTrash}
                        label="Delete"
                        onClick={this.handleDelete}
                        disabled={!isConfirmValid}
                    />
                </Modal.Footer>
            </Modal>
        </>
    }
}

export default DeleteRole
